import Paciente from "@/model/Paciente";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/Paciente/listar`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/Paciente/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (paciente: Paciente) => {
        const response = await httpClient.post(`/Paciente/inserir`, paciente);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (paciente: Paciente) => {
        const response = await httpClient.post(`Paciente/alterar`, paciente);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId: number) => {
        const response = await httpClient.post(`Paciente/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    MudarNumero: async (pId: number, pTelefone: string) => {
        const response = await httpClient.post(`Paciente/mudarNumero?pId=${pId}&pCelular=${pTelefone}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});